// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';
import { setCookie } from '../../../js/lib/cookies';

const COOKIE_NAME = "ga_hph";

function GlobalAlerts(el) {
  const ui = {
    el,
    dismiss: select(".global-alerts__dismiss", el),
    alertBtns: select.all('.js-dismiss', el),
    alertsList: select('.global-alerts__children', el),
  };

  const addEvents = async () => {
    // dismiss all alerts by clicking the dimiss button
    if (ui.dismiss) {
      ui.dismiss.addEventListener('click', e => {

        // set the cookie to close this container?
        const alertTimestamp = ui.el.getAttribute('data-alert-timestamp');
        setCookie(COOKIE_NAME, alertTimestamp, 30);

        // Hide all alerts with animation, then remove from DOM
        ui.alertsList
          .animate([
            { opacity: 1 },
            { opacity: 0 }
          ], { duration: 300, fill: 'forwards' })
          .onfinish = () => {

            // Fade the dismiss button first so it doesn't partake in the scale transform
            ui.dismiss
              .animate([
                { opacity: 1 },
                { opacity: 0 }
              ], {duration: 300, fill: 'forwards'});

            ui.el
              .animate([
                { transform: "scaleY(1)", transformOrigin: "top" },
                { transform: "scaleY(0)", transformOrigin: "top" }
              ], { duration: 300, fill: 'forwards', delay: 300 })
              .onfinish = () => {
                ui.el.remove();
              };
          };
      });
    }
  };

  const init = () => {
    addEvents();
  };

  init();
}

export default GlobalAlerts;
